import type { MatrixCall } from "matrix-js-sdk/lib/webrtc/call";

export const MATRIX_CALL_RINGING_EVENT_TYPE = "org.phonehq.call.ringing" as const;

export const MATRIX_VOIP_PROTO_VERSION = "1" as const;

export interface MatrixCallRingingContent {
    readonly call_id: string;
    readonly party_id: string;
    readonly version: typeof MATRIX_VOIP_PROTO_VERSION;
}

export const buildCallRingingContent = (
    call: Pick<MatrixCall, "callId" | "ourPartyId">,
): MatrixCallRingingContent => ({
    call_id: call.callId,
    party_id: call.ourPartyId,
    version: MATRIX_VOIP_PROTO_VERSION,
});

export const isValidCallRingingContent = (content: unknown): content is MatrixCallRingingContent => {
    if (typeof content !== "object" || content === null) return false;
    const { call_id: callId, party_id: partyId, version } = content as Record<string, unknown>;
    return typeof callId === "string" && callId.length > 0
        && typeof partyId === "string" && partyId.length > 0
        && version === MATRIX_VOIP_PROTO_VERSION;
};
